// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tiles, meters and chips for the monitor page. Tokens only: no literal colours
   here, so a change to curioTokens.css reaches this page like every other. */

.UAD1YhTr2OwKKZbw_Pf2 {
  background: #fff;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  box-shadow: var(--curio-shadow-card);
  padding: 14px 16px;
  min-width: 0;
}

.LLI2q9ucFEKBa60vwtmx {
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--curio-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wHj6XLLUxlj16IGjXU_s {
  margin-top: 6px;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.1;
  color: var(--curio-text-primary);
  font-variant-numeric: tabular-nums;
}

.fWoHOuug8s6gmA2mWs5C .wHj6XLLUxlj16IGjXU_s {
  font-size: 34px;
}

.hj3hxTtlArmRGdsl5sEQ {
  margin-top: 4px;
  font-size: 12px;
  color: var(--curio-text-secondary);
}

.l8vAA6DY8ieUQHhJBbS5 .wHj6XLLUxlj16IGjXU_s {
  color: var(--curio-warning-text);
}

.Guuw_EzF_HnZonbb1V95 .wHj6XLLUxlj16IGjXU_s {
  color: var(--curio-danger-text);
}

/* ── Meter ──────────────────────────────────────────────────────────── */

.KwlGD1rQHZHqWaK4LXIy {
  padding: 4px 0 10px;
}

.f_BnycECNRxPDVFiDFIe {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 6px;
}

.IcEOYEluxqIJJfjGsJOp {
  font-size: 12px;
  color: var(--curio-text-secondary);
  font-variant-numeric: tabular-nums;
}

.OT0ZdzPOdX33AZ4Ac87T {
  height: 8px;
  border-radius: var(--curio-radius-pill);
  background: var(--curio-surface-muted);
  overflow: hidden;
}

.Nh7BONDOnuMdwwtAjCVP {
  height: 100%;
  border-radius: var(--curio-radius-pill);
  /* One hue against its own track: a meter compares a part to a whole, so a
     second colour would imply a second series that does not exist. */
  background: var(--curio-text-primary);
  transition: width 240ms ease;
}

.Nh7BONDOnuMdwwtAjCVP.l8vAA6DY8ieUQHhJBbS5 {
  background: var(--curio-warning-text);
}

.Nh7BONDOnuMdwwtAjCVP.Guuw_EzF_HnZonbb1V95 {
  background: var(--curio-danger-text);
}

/* ── Chip ───────────────────────────────────────────────────────────── */

.bzQKDFfWfO0GBZWtcjmy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-bottom: 1px solid var(--curio-border);
  min-width: 0;
}

.bzQKDFfWfO0GBZWtcjmy:last-child {
  border-bottom: none;
}

.PuRSRHmnDkqrRa424ZQc {
  font-size: 13px;
  color: var(--curio-text-secondary);
  white-space: nowrap;
}

.jm9idWolfL6hZcsYpUOL {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: var(--curio-radius-pill);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
}

.t5SjKEh61DKL3M1g86sI {
  background: var(--curio-surface-muted);
  color: var(--curio-text-secondary);
}

.NnOZClbruuPpGf0RwmD2 {
  background: var(--curio-success-bg);
  color: var(--curio-success-text);
}

.L9EnZZthW7UqsfWERVNM {
  background: var(--curio-warning-bg);
  color: var(--curio-warning-text);
}

.pySkZImbvetIxNjiaJx5 {
  background: var(--curio-danger-bg);
  color: var(--curio-danger-text);
}
`, "",{"version":3,"sources":["webpack://./src/pages/monitor/StatTile.module.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,0EAA0E;;AAE1E;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC;qEACmE;EACnE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC","sourcesContent":["/* Tiles, meters and chips for the monitor page. Tokens only: no literal colours\n   here, so a change to curioTokens.css reaches this page like every other. */\n\n.tile {\n  background: #fff;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  box-shadow: var(--curio-shadow-card);\n  padding: 14px 16px;\n  min-width: 0;\n}\n\n.label {\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--curio-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.value {\n  margin-top: 6px;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.1;\n  color: var(--curio-text-primary);\n  font-variant-numeric: tabular-nums;\n}\n\n.hero .value {\n  font-size: 34px;\n}\n\n.sub {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--curio-text-secondary);\n}\n\n.warn .value {\n  color: var(--curio-warning-text);\n}\n\n.danger .value {\n  color: var(--curio-danger-text);\n}\n\n/* ── Meter ──────────────────────────────────────────────────────────── */\n\n.meterBlock {\n  padding: 4px 0 10px;\n}\n\n.meterHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.meterCaption {\n  font-size: 12px;\n  color: var(--curio-text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n.meterTrack {\n  height: 8px;\n  border-radius: var(--curio-radius-pill);\n  background: var(--curio-surface-muted);\n  overflow: hidden;\n}\n\n.meterFill {\n  height: 100%;\n  border-radius: var(--curio-radius-pill);\n  /* One hue against its own track: a meter compares a part to a whole, so a\n     second colour would imply a second series that does not exist. */\n  background: var(--curio-text-primary);\n  transition: width 240ms ease;\n}\n\n.meterFill.warn {\n  background: var(--curio-warning-text);\n}\n\n.meterFill.danger {\n  background: var(--curio-danger-text);\n}\n\n/* ── Chip ───────────────────────────────────────────────────────────── */\n\n.chipRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 7px 0;\n  border-bottom: 1px solid var(--curio-border);\n  min-width: 0;\n}\n\n.chipRow:last-child {\n  border-bottom: none;\n}\n\n.chipLabel {\n  font-size: 13px;\n  color: var(--curio-text-secondary);\n  white-space: nowrap;\n}\n\n.chip {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: var(--curio-radius-pill);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 60%;\n}\n\n.chip_neutral {\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-secondary);\n}\n\n.chip_good {\n  background: var(--curio-success-bg);\n  color: var(--curio-success-text);\n}\n\n.chip_warn {\n  background: var(--curio-warning-bg);\n  color: var(--curio-warning-text);\n}\n\n.chip_danger {\n  background: var(--curio-danger-bg);\n  color: var(--curio-danger-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `UAD1YhTr2OwKKZbw_Pf2`,
	"label": `LLI2q9ucFEKBa60vwtmx`,
	"value": `wHj6XLLUxlj16IGjXU_s`,
	"hero": `fWoHOuug8s6gmA2mWs5C`,
	"sub": `hj3hxTtlArmRGdsl5sEQ`,
	"warn": `l8vAA6DY8ieUQHhJBbS5`,
	"danger": `Guuw_EzF_HnZonbb1V95`,
	"meterBlock": `KwlGD1rQHZHqWaK4LXIy`,
	"meterHead": `f_BnycECNRxPDVFiDFIe`,
	"meterCaption": `IcEOYEluxqIJJfjGsJOp`,
	"meterTrack": `OT0ZdzPOdX33AZ4Ac87T`,
	"meterFill": `Nh7BONDOnuMdwwtAjCVP`,
	"chipRow": `bzQKDFfWfO0GBZWtcjmy`,
	"chipLabel": `PuRSRHmnDkqrRa424ZQc`,
	"chip": `jm9idWolfL6hZcsYpUOL`,
	"chip_neutral": `t5SjKEh61DKL3M1g86sI`,
	"chip_good": `NnOZClbruuPpGf0RwmD2`,
	"chip_warn": `L9EnZZthW7UqsfWERVNM`,
	"chip_danger": `pySkZImbvetIxNjiaJx5`
};
export default ___CSS_LOADER_EXPORT___;
